<template>
    <teleport to="#footerCustomNavItems">
        <slot />
    </teleport>
</template>

<script lang="ts">

import {usePageHost} from "../utils/usePageHost";
import {defineComponent} from "vue";

export default defineComponent({
    name: "AunoaFooterCommandsPane",
    setup: () => usePageHost().withTeleport("footerCommands")
});

</script>
